var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"audio-tour-page"},[_c('AudioTour',{attrs:{"slides":_vm.slides}}),_c('PageDescription',{attrs:{"post":_vm.post}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }